import { render, staticRenderFns } from "./loginSelectOrg.vue?vue&type=template&id=8715bb10&scoped=true&"
import script from "./loginSelectOrg.vue?vue&type=script&lang=js&"
export * from "./loginSelectOrg.vue?vue&type=script&lang=js&"
import style0 from "./loginSelectOrg.vue?vue&type=style&index=0&id=8715bb10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8715bb10",
  null
  
)

export default component.exports